import { ColorPicker, Form, Input, Select, Upload } from "antd";
import Button from "./Button";
import { UploadOutlined } from "@ant-design/icons";
import { useState } from "react";
const { Option } = Select;

export default function OverviewForm() {
  const [file, setFile] = useState(null); // State to store the uploaded file

  const onFinish = (values) => {
    // Manually add the file to the form data
    const formData = { ...values, file: file };
  };

  // Handle file change event (including replacing the file when a new one is uploaded)
  const handleFileChange = (info) => {
    const { fileList } = info; // Get the list of files
    if (fileList.length > 0) {
      const newFile = fileList[0].originFileObj; // Get the first file
      setFile(newFile); // Set the new file, replacing the old one
    }
  };

  // Custom request handler (prevents immediate upload)
  const customRequest = ({ file, onSuccess }) => {
    // Here we just capture the file, we don't send it anywhere
    // We simulate a successful request without uploading the file
    onSuccess("ok"); // Simulate success
    setFile(file); // Update the file state with the selected file
  };

  return (
    <Form
      className="rewards-form-container"
      onFinish={onFinish}
      layout="vertical"
    >
      <div className="rewards-form-section">
        <h4>Details</h4>
        <div className="rewards-inputs">
          <div className="form-row">
            <Form.Item
              name="name"
              label="Reward name"
              rules={[{ required: true, message: "Please input reward name!" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="category"
              label="Category"
              rules={[{ required: true }]}
            >
              <Select style={{ width: "100%" }} placeholder="Select Category">
                <Option value="active">Active</Option>
                <Option value="inactive">Inactive</Option>
              </Select>
            </Form.Item>
          </div>
        </div>
      </div>

      <div className="rewards-form-section">
        <h4>Branding</h4>
        <div className="rewards-inputs">
          <Form.Item
            style={{ marginBottom: "2rem" }}
            name="file"
            label="Select your Logo"
          >
            <Upload
              customRequest={customRequest} // Custom request to disable the default upload behavior
              onChange={handleFileChange} // Handle file change
              maxCount={1}
            >
              <Button variant="secondary" icon={<UploadOutlined />}>
                Upload Image
              </Button>
            </Upload>
          </Form.Item>
          <div className="form-row">
            <Form.Item
              name="brandColor"
              label="Pick a brand color"
              rules={[
                { required: true, message: "Please pick a brand color!" },
              ]}
            >
              <ColorPicker
                style={{ width: "100%" }}
                defaultValue="#1677ff"
                showText
              />
            </Form.Item>
            <Form.Item
              name="accentColor"
              label="Pick an accent color"
              rules={[{ required: true }]}
            >
              <ColorPicker
                style={{ width: "100%" }}
                defaultValue="#1677ff"
                showText
              />
            </Form.Item>
          </div>
        </div>
      </div>

      <div className="rewards-form-section">
        <h4>Location</h4>
        <div className="rewards-inputs">
          <Form.Item name="locationHint" label="Location Name" required>
            <Input />
          </Form.Item>
        </div>
      </div>

      <div className="rewards-form-section">
        <h4>Contact</h4>
        <div className="rewards-inputs">
          <Form.Item
            name="supportEmail"
            label="Customer support email"
            required
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="supportNumber"
            label="Customer support number"
            required
          >
            <Input />
          </Form.Item>
          <Form.Item name="website" label="Website address " required>
            <Input />
          </Form.Item>
        </div>
      </div>

      <div className="rewards-form-section">
        <h4>Social</h4>
        <div className="rewards-inputs">
          <Form.Item name="fbLink" label="Facebook link" required>
            <Input />
          </Form.Item>
          <Form.Item name="instagramLink" label="Instagram link" required>
            <Input />
          </Form.Item>
          <Form.Item name="xLink" label="X link" required>
            <Input />
          </Form.Item>
        </div>
      </div>

      <Form.Item className="rewards-form-btn">
        <Button>Submit</Button>
      </Form.Item>
    </Form>
  );
}
